/**
 * Inbox: the Вхідна screen (ADR-0008) — what arrived from every source and is not sorted yet, and
 * what the triager could not decide without the human.
 */
export const inbox = {
  'nav.inbox': 'Вхідна',
  'inbox.title': 'Вхідна',
  'inbox.intro': 'Усе, що прийшло само: скріни, «Збережене» в Telegram, вкладки, відео. Розбирач кілька разів на день робить із цього задачі й знахідки; тут лишається лише нерозібране і те, де потрібні ви.',
  'inbox.empty': 'Нерозібраного немає.',
  'inbox.notFound': 'Запис не знайдено',
  'inbox.summary': 'Нового: {new} · Потрібні ви: {needs} · Розібрано сьогодні: {sorted}',
  'inbox.shown': 'Показано {shown} з {total} · сторінка {page}',
  'inbox.page.prev': 'Назад',
  'inbox.page.next': 'Далі',
  'inbox.filter.allBusinesses': 'Усі бізнеси',
  'inbox.filter.allSources': 'Усі джерела',
  'inbox.chip.open': 'Усе нерозібране',
  'inbox.status.new': 'Нове',
  'inbox.status.needs_human': 'Потрібні ви',
  'inbox.status.done': 'Розібрано',
  'inbox.status.trash': 'Сміття',
  'inbox.source.photos': 'Фото',
  'inbox.source.telegram': 'Telegram',
  'inbox.source.youtube': 'YouTube',
  'inbox.source.zoom': 'Zoom',
  'inbox.source.mail': 'Пошта',
  'inbox.source.browser_tab': 'Вкладка',
  'inbox.source.dialog': 'Розмова Claude',
  'inbox.source.notebook': 'Блокнот',
  'inbox.source.manual': 'Вручну',
  'inbox.outcome.task': 'задача',
  'inbox.outcome.finding': 'знахідка',
  'inbox.outcome.funnel_case': 'воронка-кейс',
  'inbox.outcome.knowledge_source': 'джерело знань',
  'inbox.outcome.reference': 'довідка',
  'inbox.outcome.nothing': 'нічого',
  'inbox.col.what': 'Що',
  'inbox.col.source': 'Джерело',
  'inbox.col.business': 'Бізнес',
  'inbox.col.status': 'Стан',
  'inbox.col.captured': 'Коли',
  'inbox.noTitle': 'Без тексту',
  'inbox.noBusiness': '—',
  'inbox.detail.close': 'Закрити',
  'inbox.detail.captured': 'з’явилось {when}',
  'inbox.detail.open': 'Відкрити джерело',
  'inbox.detail.file': 'Файл: {name}',
  'inbox.detail.text': 'Текст',
  'inbox.detail.question': 'Питання розбирача',
  'inbox.detail.note': 'Нотатка розбирача',
  'inbox.detail.result': 'Результат: {outcome}',
  'inbox.detail.tasks': 'Задачі з цього запису',
  'inbox.detail.openKnowledge': 'відкрити в «Знаннях»',
  'inbox.detail.cleared': 'Прибрано з джерела {when}',
  'inbox.answer.label': 'Ваша відповідь розбирачу',
  'inbox.answer.hint': 'Запис повернеться розбирачу з вашою відповіддю, і він розбере його наступного разу.',
  'inbox.answer.send': 'Відповісти',
  'inbox.action.reference': 'Залишити як довідку',
  'inbox.action.trash': 'У сміття',
} as const;
